import { useTranslation } from "react-i18next";
import { reviewWindowStatuses, type ReviewWindowStatus } from "./helpers";
import { useText } from "./text";

// The window colours of both views; the wheel fills its arcs, the timeline its bars
export const windowStatusFill: Record<ReviewWindowStatus, string> = {
  done: "fill-secondary",
  ongoing: "fill-primary",
  upcoming: "fill-info",
};

export const useWindowStatusLabel = (): Record<ReviewWindowStatus, string> => {
  const { t } = useTranslation();
  const text = useText();

  return {
    done: text.done,
    ongoing: t(($) => $.commons.workflow.ongoing),
    upcoming: t(($) => $.commons.workflow.upcoming),
  };
};

export const ReviewWindowStatusLegend = ({ opacity }: { opacity: number }) => {
  const statusLabel = useWindowStatusLabel();

  return (
    <ul
      className="flex flex-wrap justify-center gap-x-6 gap-y-1 text-sm"
      style={{ opacity }}
      aria-hidden
    >
      {reviewWindowStatuses.map((status) => (
        <li key={status} className="flex items-center gap-2">
          <svg viewBox="0 0 12 12" className="size-3" aria-hidden>
            <rect
              width={12}
              height={12}
              rx={3}
              className={windowStatusFill[status]}
            />
          </svg>
          {statusLabel[status]}
        </li>
      ))}
    </ul>
  );
};
